/* exported  addToCart */
async function addToCart(formData) {
	try {
		return fetch(window.Shopify.routes.root + 'cart/add.js', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(formData),
		});
	} catch (error) {
		return error;
	}
}
